module.exports = __webpack_public_path__ + "static/torii-logo-e3a566c0d07a623c6400fa88804da2d7.png";